var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmClockMeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5322_21616)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.125,
    r: 5.625,
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 11.875L1.875 13.125M11.875 11.875L13.125 13.125",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.23106L12.2472 2.04497C12.7755 1.78083 12.9739 1.81106 13.3939 2.23106C13.8139 2.65107 13.8442 2.84953 13.58 3.37782L13.3939 3.75M3.125 2.23106L2.75281 2.04497C2.22453 1.78083 2.02607 1.81106 1.60606 2.23106C1.18606 2.65107 1.15583 2.84953 1.41997 3.37782L1.60606 3.75",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.9375V8.4375L8.75 9.6875",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.1875V1.25",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 1.25H8.75",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5322_21616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockMeetings);
export default __webpack_public_path__ + "static/media/AlarmClockMeetings.418261470b91d507608d0588a0518625.svg";
export { ForwardRef as ReactComponent };